import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { InviteSummary } from "../../types/apiv1";
import { changeOrganization } from "./session";

export enum RejectionReason {
	Network,
	Bug,
};

export type InviteSummaryStateInitializing = {
	kind: 'initializing',
	pending:  boolean,
	rejectionReason?: RejectionReason,
};

export type InviteSummaryStateReady = {
	kind: 'ready',
	inviteSummarys: InviteSummary[],
};

export type InviteSummaryState = InviteSummaryStateInitializing | InviteSummaryStateReady;

const initialState = {
	kind: 'initializing',
} as InviteSummaryState;

export const inviteSummarySlice = createSlice({
	name: 'inviteSummarys',
	initialState,
	reducers: {
		reset: (state, action: PayloadAction<RejectionReason | undefined>): InviteSummaryState => {
			return {
				kind: 'initializing',
				pending: false,
				rejectionReason: action.payload,
			};
		},
		pending: (state): InviteSummaryState => {
			return {
				kind: 'initializing',
				pending: true,
			}
		},
		ready: (state, action: PayloadAction<InviteSummary[]>): InviteSummaryState => {
			return {
				kind: 'ready',
				inviteSummarys: action.payload,
			};
		},
	},
	extraReducers: (builder) => {
		builder.addCase(changeOrganization, (): InviteSummaryState => {
			return {
				kind: 'initializing',
				pending: false,
			};
		})
	}
});

export const { reset, pending, ready } = inviteSummarySlice.actions;
export default inviteSummarySlice.reducer;
